module.exports = __webpack_public_path__ + "static/img/no-data-small.92f73c11.png";